module.exports = __webpack_public_path__ + "img/07_1.fb077c24.png";